import { sanitizeRichHtml } from "../../shared/safeHtml";
import type { Ticket } from "./types";

export type AgentNote = NonNullable<Ticket["agentNote"]>;
export type NoteDraft = { body: string; html: string; expectedRevision: number; originalBody: string; originalHtml: string };

export function ticketNoteHtml(note?: AgentNote): string {
  if (note?.bodyHtml) return sanitizeRichHtml(note.bodyHtml, 100000) || "";
  const escape = (value: string) => value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
  // Legacy notes are plain text, never interpret them as HTML. Linkify URLs
  // so the read-only view remains useful before the first rich-text edit.
  const html = (note?.body || "").split(/(https?:\/\/[^\s<>]+)/g).map((part, index) => index % 2
    ? `<a href="${escape(part)}">${escape(part)}</a>` : escape(part)).join("").replace(/\r\n?|\n/g, "<br>");
  return sanitizeRichHtml(html, 200000) || "";
}

export function startNoteDraft(note?: AgentNote): NoteDraft {
  const html = ticketNoteHtml(note), body = note?.body || "";
  return { body, html, expectedRevision: note?.revision || 0, originalBody: body, originalHtml: html };
}

export function noteDraftChanged(draft: NoteDraft): boolean {
  return draft.body !== draft.originalBody || draft.html !== draft.originalHtml;
}
